__turbopack_context__.v({
  "desktopGrid": "ArticlesGrid-module-scss-module__b80JRa__desktopGrid",
  "desktopHeader": "ArticlesGrid-module-scss-module__b80JRa__desktopHeader",
  "desktopHeaderTitle": "ArticlesGrid-module-scss-module__b80JRa__desktopHeaderTitle",
  "loadMoreWrapper": "ArticlesGrid-module-scss-module__b80JRa__loadMoreWrapper",
  "mobileHeader": "ArticlesGrid-module-scss-module__b80JRa__mobileHeader",
  "mobileHeaderIcon": "ArticlesGrid-module-scss-module__b80JRa__mobileHeaderIcon",
  "mobileHeaderTitle": "ArticlesGrid-module-scss-module__b80JRa__mobileHeaderTitle",
  "mobileHorizontal": "ArticlesGrid-module-scss-module__b80JRa__mobileHorizontal",
  "mobileVertical": "ArticlesGrid-module-scss-module__b80JRa__mobileVertical",
  "normal": "ArticlesGrid-module-scss-module__b80JRa__normal",
  "outlineButton": "ArticlesGrid-module-scss-module__b80JRa__outlineButton",
  "prominent": "ArticlesGrid-module-scss-module__b80JRa__prominent",
  "swiperFull": "ArticlesGrid-module-scss-module__b80JRa__swiperFull",
  "swiperSlide": "ArticlesGrid-module-scss-module__b80JRa__swiperSlide",
});
